// FormData is required for sending files
export default function ( assetName, asset, files ) {
	const data = new FormData();

	if ( files && files.length ) {

		files.forEach( ( file, i ) => {
			if ( file instanceof File ) {
				data.append( `attachments${i}`, file, file.name );
			}
		} );

	}

	data.append( assetName, JSON.stringify( asset ) );

	return data;
}
